import React, { useContext, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import LeafletMarkers from '../LeafletMarkers';
import LeafletMarkerClusters from '../LeafletMarkerClusters';
import LeafletMapContext from '../LeafletMapContextProvider';
var LeafletMarkerLayer = function LeafletMarkerLayer(props) {
  var map = useMap();
  var _useContext = useContext(LeafletMapContext),
    setSelectedMarker = _useContext.setSelectedMarker;
  var markers = props.markers,
    moveToMarkerOnClick = props.moveToMarkerOnClick,
    zoomOnClick = props.zoomOnClick,
    zoomLevelOnClick = props.zoomLevelOnClick,
    markerClickFocus = props.markerClickFocus,
    focusPadding = props.focusPadding,
    onMarkerClick = props.onMarkerClick,
    _props$showClusters = props.showClusters,
    showClusters = _props$showClusters === void 0 ? false : _props$showClusters,
    clusterGroupIconConstructor = props.clusterGroupIconConstructor,
    showPopup = props.showPopup,
    popupContentConstructor = props.popupContentConstructor,
    zoomToBoundsOnClick = props.zoomToBoundsOnClick,
    showCoverageOnHover = props.showCoverageOnHover,
    removeOutsideVisibleBounds = props.removeOutsideVisibleBounds,
    spiderfyDistanceMultiplier = props.spiderfyDistanceMultiplier,
    spiderfy = props.spiderfy,
    spiderfyShapePositions = props.spiderfyShapePositions,
    onMarkerClusterClick = props.onMarkerClusterClick;
  useEffect(function () {
    map.on('click', function () {
      setSelectedMarker(null);
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "MarkerLayer"
  }, showClusters && /*#__PURE__*/React.createElement(LeafletMarkerClusters, {
    markers: markers,
    moveToMarkerOnClick: moveToMarkerOnClick,
    zoomOnClick: zoomOnClick,
    zoomLevelOnClick: zoomLevelOnClick,
    markerClickFocus: markerClickFocus,
    focusPadding: focusPadding,
    onMarkerClick: onMarkerClick,
    clusterGroupIconConstructor: clusterGroupIconConstructor,
    zoomToBoundsOnClick: zoomToBoundsOnClick,
    showCoverageOnHover: showCoverageOnHover,
    removeOutsideVisibleBounds: removeOutsideVisibleBounds,
    spiderfyDistanceMultiplier: spiderfyDistanceMultiplier,
    spiderfy: spiderfy,
    spiderfyShapePositions: spiderfyShapePositions,
    onMarkerClusterClick: onMarkerClusterClick,
    showPopup: showPopup,
    popupContentConstructor: popupContentConstructor
  }), !showClusters && /*#__PURE__*/React.createElement(LeafletMarkers, {
    markers: markers,
    moveToMarkerOnClick: moveToMarkerOnClick,
    zoomOnClick: zoomOnClick,
    zoomLevelOnClick: zoomLevelOnClick,
    markerClickFocus: markerClickFocus,
    focusPadding: focusPadding,
    onMarkerClick: onMarkerClick,
    showPopup: showPopup,
    popupContentConstructor: popupContentConstructor
  }));
};
export default LeafletMarkerLayer;